<header class="app-header navbar navbar-dark navbar-expand-md">
  <div class="container-fluid">
    <ul class="ml-auto user-navigation">
      <li *ngIf="currentUser.userProfile === 'mipluxee'"><a routerLink="/mipluxee/mi-perfil">Mi Perfil</a></li>
      <li><a href="javascript:void(0)" (click)="logout()">Cerrar sesión</a></li>
    </ul>
  </div>
</header>
